import React from "react";

import AddressesAdmin from "../components/dashboard/addresses_admin";
import Addresses from "../components/dashboard/addresses";
import Users from "../components/dashboard/users";
import Security from "../components/dashboard/security";
import CsvUpload from "../components/dashboard/CsvUpload";
import Rewards from "../components/dashboard/rewards";
import RewardLogs from "../components/dashboard/rewardLogs";
import LuminousRewardsPage from "../components/dashboard/LuminousRewards";
import Distribute from "../components/dashboard/distribute";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/`, Component: <Addresses /> },
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Addresses /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Addresses /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/admin`, Component: <AddressesAdmin /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/users`, Component: <Users /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/security`, Component: <Security /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/csv`, Component: <CsvUpload /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/rewards`, Component: <Rewards /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/logs`, Component: <RewardLogs /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/luminous`, Component: <LuminousRewardsPage /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/distribute`, Component: <Distribute /> },
];
